export default __webpack_public_path__ + "static/media/icon_time.beaef2a4.svg";